import {useMemo, useRef} from "react";
import {api} from "../../../../api/API";
import {useProjectId} from "../../shopdrawing/ProjectName";
import {useAlternative} from "../alternative/Alternative";

export function useShortCodeSearch() {
    const project = useProjectId();
    const alternative = useAlternative();

    const defaultSearchP = useMemo(() => {
        return api.hardwareLibrary.getShortCodes({
            search: "",
            project,
            alternative,
            type: "hardware",
        })
    }, [project, alternative]);

    const search = async (search: string) => {
        if(search === "") {
            return defaultSearchP.then(v => v.map(v => ({
                display: v.value,
                value: v.value,
            })))
        }

        const list = await api.hardwareLibrary.getShortCodes({
            search,
            project,
            alternative,
            type: "hardware",
        });

        return list.map(v => ({
            display: v.value,
            value: v.value,
        }))
    }

    const ref = useRef(search)
    ref.current = search;

    return ref;
}